import qs from "qs";
import authAxios, { authHeader } from "./data";

const fetchAll = async (request: any) => {
  const response = await authAxios.get("/api/IncidentReports", {
    params: request,
    paramsSerializer: (params) => {
      return qs.stringify(params);
    },
    headers: authHeader(),
  });

  return response.data;
};

const fetchCount = async (request: any) => {
  const response = await authAxios.get("/api/IncidentReports/Count", {
    params: request,
    paramsSerializer: (params) => {
      return qs.stringify(params);
    },
    headers: authHeader(),
  });

  return response.data;
};

const fetch = async (id: string) => {
  const response = await authAxios.get(`/api/IncidentReports/${id}`, {
    headers: authHeader(),
  });

  return response.data;
};

const create = async (entry: any) => {
  const response = await authAxios.post("/api/IncidentReports", entry, {
    headers: authHeader(),
  });

  return response.data;
};

const remove = async (id: string) => {
  const response = await authAxios.delete(`/api/IncidentReports/${id}`, {
    headers: authHeader(),
  });

  return response.data;
};

const getExcel = async (request: any) => {
  const response = await authAxios.get("/api/Export/IncidentReports", {
    params: request,
    paramsSerializer: (params) => {
      return qs.stringify(params);
    },
    headers: authHeader(),
    responseType: "blob",
  });

  return response.data;
};

const IncidentReportsService = {
  fetchAll,
  fetchCount,
  fetch,
  create,
  remove,
  getExcel,
};

export default IncidentReportsService;
